export default __webpack_public_path__ + "static/media/297.8e8d3e83.gif";